import React from "react";
import { Element } from "react-scroll";
import { NavLink } from "react-router-dom";

import classNames from "classnames";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

import SyncIcon from "components/SyncSelect/SyncIcon";

import SidebarItemType from "./SidebarItemType";
import {
  Attendance,
  attendanceStoreSidebarItemStyling,
} from "data-handler/ducks/stores";

import "./_sidebar.scss";
import { getIdToNoMealReasonMapping } from "data-handler/ducks/noMealReasons";
import { useSelector } from "react-redux";

type SidebarItemProps = {
  additionalRight?: React.ReactNode;
  icon?: React.ReactElement;
  selected: boolean;
  title: React.ReactElement;
  subTitle: React.ReactElement | boolean;
  thrTitle?: React.ReactElement | null | boolean;
  to: string;

  id?: number | string;
  comment?: React.ReactElement | boolean;
  kind?: string;
  highlight?: boolean;
  store?: Attendance;
  studentStore?: Attendance;
  thrStore?: Attendance;
  currentSchoolEnabledStudentAttendance?: boolean;
  [key: string]: unknown;
};

const SidebarItem: React.ElementType<SidebarItemProps> = ({
  children,
  additionalRight,
  comment,
  icon,
  id,
  kind,
  highlight,
  selected,
  store,
  studentStore,
  currentSchoolEnabledStudentAttendance,
  subTitle,
  thrTitle,
  title,
  to,
}) => {
  // Call to the useSelector hook in order to get the idToNoMealReasonMapping
  const idToNoMealReasonMapping = useSelector(getIdToNoMealReasonMapping);

  // If the category is 'non-wfp', completely exclude the component
  if (store?.category === "non-wfp") {
    return null;
  }

  const classes = classNames({
    "sidebar-item": true,
    "sidebar-item--highlight": highlight,
    "sidebar-item--sync": kind === "sync",
    "sidebar-item--selected": selected,
    [`sidebar-item--${store && (store.model || store.event_type)}`]:
      store && (store.model || store.event_type),
  });

  const date =
    store && ((store as any).occurred_at || (store as any).occurred_on);

  return (
    <Element
      key={id}
      className="sidebar-item__wrapper"
      name={`scroll-${store && store.client_id}`}
      style={attendanceStoreSidebarItemStyling(
        store!,
        studentStore!,
        currentSchoolEnabledStudentAttendance!,
        idToNoMealReasonMapping
      )}
    >
      <NavLink
        className={classes}
        to={to ? to : "no link defined"}
        role="button"
        tabIndex={-2}
      >
        {icon && <div className="sidebar-item__icon">{icon}</div>}
        <div className="sidebar-item__content">
          <div className="sidebar-item__type">
            <SidebarItemType
              store={store!}
              currentSchoolEnabledStudentAttendance={
                currentSchoolEnabledStudentAttendance!
              }
            />
          </div>
          <h5 className="sidebar-item__title">
            {title}
            {highlight && <FontAwesomeIcon icon={faChevronRight} />}
          </h5>
          <div className="sidebar-item__sub-title">{subTitle}</div>
          <p className="sidebar-item__comment">{comment}</p>

          {children}
          {thrTitle && <p className="sidebar-item__thr-title">{thrTitle}</p>}
        </div>
        <div className="sidebar-item__info">
          {additionalRight}
          {date && (
            <div className="sidebar-item__date">
              <span>{moment(date).format("dddd")}</span>
              <span>{moment(date).format("DD.MM.YYYY")}</span>
            </div>
          )}
          {/* store.sync is undefined for reports */}
          {store && store.sync !== undefined && (
            <SyncIcon isSynced={store.sync} type={store.type} />
          )}
        </div>
      </NavLink>
    </Element>
  );
};

export default SidebarItem;
